import { setOptions } from '@googlemaps/js-api-loader';

// Google's recommended channel for most apps: the latest stable release, with
// weekly bug fixes and features. This is effectively what prod already ran, as
// the old eager script's `v=3.61` is retired and silently fell back to weekly.
// https://developers.google.com/maps/documentation/javascript/versions#choosing-the-weekly-channel
const MAPS_CHANNEL = 'weekly';

type BootstrapParams = {
  apiKey: string;
};

/**
 * Configures Google's Dynamic Library Import loader. Installs the global
 * `google.maps.importLibrary` synchronously but injects no Maps JS until the
 * first `importLibrary(...)` call. Safe to call more than once; repeat calls
 * are ignored by the loader.
 */
export function bootstrapGoogleMaps({ apiKey }: BootstrapParams): void {
  setOptions({ key: apiKey, v: MAPS_CHANNEL });
}
